import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import Skeleton from "@/components/common/skeleton"
import success from "@/assets/images/welcomeNew.svg" // Adjust the path as necessary
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary
import { MdClose } from "react-icons/md"

const WelcomeHome = () => {
  const [isLoadingImage, setIsLoadingImage] = useState(true)

  const handleImageLoad = () => {
    setIsLoadingImage(false)
  }
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleRedirect = () => {
    // Navigate to the first URL
    navigate("/", { replace: true })
    // Then navigate to the second URL
    setTimeout(() => {
      navigate("/subscription")
    }, 50) // Ensure it happens immediately after
  }
  return (
    <div
      className=" d-flex flex-column flex-md-row row mt-5 mt-md-0  align-items-center justify-content-between  ms-0 me-1 ms-md-2 me-md-2 mb-5 "
      style={{
        minHeight: "60vh",
        margin: "0 0rem",
      }} // Ensure full height and margin
    >
      <div className=" col-12 col-md-6 d-flex flex-column gap-3 align-items-center  ">
        <h5
          className="text-blue fs-1 fs-lg-1 "
          style={{ color: "#245192", fontWeight: 500, fontFamily: "Poppins" }}
        >
          {" "}
          {t("welcome.welcomeToInviteSmartApp")}
        </h5>
        <span
          className=" fs-5"
          style={{
            fontFamily: "Poppins",
            color: "#959699",
            fontWeight: "normal",
          }}
        >
          {t("welcome.pleaseChooseOneOfTheOptionsBelow")}
        </span>

        <div className="d-flex flex-column flex-md-row  lg:flex-row  gap-2 ms-1 me-1  w-full mt-3 ">
          <Link
            style={{
              borderRadius: "5px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              paddingBottom: "10px",
              backgroundColor: "#245192",
              width: "200px",
              fontFamily: "Inter",
            }}
            className="  mb-4 md:mb-0  border-0 mt-0 text-white border- d-flex justify-content-center align-items-center reminders-page__link-container "
            to="/whatsapp"
            // onClick={handleRedirect}
          >
            {t("welcome.loginWithPhone")}
          </Link>

          <Link
            style={{
              borderRadius: "5px",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "10px",
              paddingBottom: "10px",
              height: "45px",
              border: "1px solid #245192",
              color: "#245192",
              width: "200px",
              fontFamily: "Inter",
            }}
            className=" mt-0 fw-normal  bg-light border- d-flex justify-content-center align-items-center reminders-page__link-container"
            to="/login"
          >
            {t("welcome.loginWithEmail")}{" "}
          </Link>
        </div>
      </div>
      <div
        className=" col-12 col-md-6 d-flex flex-column align-items-center lg:align-items-start  m-0 p-0 "
        style={{ minHeight: "300px" }}
      >
        {/* {isLoadingImage && (
          <Skeleton width="350px" height="400px" borderRadius="8px" />
        )} */}
        <img
          src={success}
          // width="100%"
          // height="400px"
          style={{
            maxHeight: "400px",
            maxWidth: "100%",
            objectFit: "contain",
            // display: isLoadingImage ? "none" : "flex",
            display: "flex",
          }}
          // onLoad={handleImageLoad}
        />
      </div>{" "}
      <div
        className="rounded-3 d-none d-md-flex shadow-sm p-4 me-3 ms-auto bottom-0 align-items-start d-flex justify-content-between gap-3"
        style={{
          maxWidth: "400px",
          backgroundColor: "#ffffff",
          borderRadius: "6px", // rounded corners for a card-like look
          padding: "20px", // adjust padding for better spacing
        }}
      >
        <img
          src={invitesmart}
          // width="100%"
          // height="400px"
          style={{
            height: "40px",
            width: "40px",
            objectFit: "contain",
          }}
        />
        <div className="d-flex flex-column gap-2">
          <h6 className="d-flex fs-5   fw-bold">INVITE SMART</h6>
          <span className="d-flex text-muted" style={{ fontSize: "15px" }}>
            You can now use Add Invite button to connect and invite your loved
            ones in your celebration!
          </span>
        </div>
      </div>
    </div>
  )
}
export default WelcomeHome
